import ReactGA from "react-ga";
import ReactGA4 from "react-ga4";
import { getAnalytics } from "./head/analytics";
import {
  ANALYTICS,
  AGENTSTRACKER,
  INHOUSETRACKER,
} from "../../constants/constants";

//TODO test to see if REACTGA is working as intended
exports.event = function (category, action, label) {
  const gaValue = getAnalytics();
  if (gaValue.length > 0) {
    if (gaValue === ANALYTICS.GA4 && ReactGA4) {
      ReactGA4.event(
        {
          category: category,
          action: action,
          label: label,
        },
        [AGENTSTRACKER, INHOUSETRACKER]
      );
    } else if (gaValue === ANALYTICS.GA && ReactGA) {
      ReactGA.event({
        category: category,
        action: action,
        label: label,
      });
    }
  }
};

exports.social = function (network, action) {
  const gaValue = getAnalytics();
  if (gaValue.length > 0) {
    if (gaValue === ANALYTICS.GA4 && ReactGA4) {
      ReactGA4.event(
        {
          category: "social",
          action: action,
          label: network,
        },
        [AGENTSTRACKER, INHOUSETRACKER]
      );
    } else if (gaValue === ANALYTICS.GA && ReactGA) {
      ReactGA.event({
        category: "social",
        action: action,
        label: network,
      });
    }
  }
};

exports.logPageView = function (location) {
  const gaValue = getAnalytics();
  if (gaValue.length > 0) {
    if (gaValue === ANALYTICS.GA4 && ReactGA4) {
      ReactGA4.set({ page: location.pathname }, [
        AGENTSTRACKER,
        INHOUSETRACKER,
      ]);
      ReactGA4.send({ hitType: "pageview", page: location.pathname }, [
        AGENTSTRACKER,
        INHOUSETRACKER,
      ]);
    } else if (gaValue === ANALYTICS.GA && ReactGA) {
      ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/shared/analytics.js